import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	helpText: {
		id: 'polaris-component-view-sort-configuration.config-sort.help-text',
		defaultMessage: 'Select the fields you want to use to sort ideas in this view',
		description: 'Help text',
	},
	saveButton: {
		id: 'polaris-component-view-sort-configuration.config-sort.save-button',
		defaultMessage: 'Keep sorted',
		description: '',
	},
	resetButton: {
		id: 'polaris-component-view-sort-configuration.config-sort.reset-button',
		defaultMessage: 'Clear sort',
		description: '',
	},
	sortFirstLabel: {
		id: 'polaris-component-view-sort-configuration.config-sort.sort-first-label',
		defaultMessage: 'Sort by',
		description: '',
	},
	sortThenLabel: {
		id: 'polaris-component-view-sort-configuration.config-sort.sort-then-label',
		defaultMessage: 'then by',
		description: '',
	},
	addButton: {
		id: 'polaris-component-view-sort-configuration.config-sort.add-button',
		defaultMessage: 'Add field',
		description: '',
	},
});
